import { useCallback } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/reducers/types";
import { UserRole } from "@/sx-layout/components/plotmap/models";
import { useUserCompanyColor } from "@/sx-layout/hooks/useUserCompanyColor";
import { normalizeHexColor } from "@/sx-layout/utils";

export const useDefaultMachineIconColor = () => {
  // 重機アイコンのデフォルトの色は以下の優先順位で決まる
  /* 1. 工事設定の重機アイコンの色 (設定されている場合) */
  const machineIconSettings = useSelector((state: RootState) => state.layoutApp.layoutMasters.machine_icons);

  /* 2. 選択した会社の色 （会社を選択している場合） */
  const userRole = useSelector((state: RootState) => state.layoutApp.layoutMasters.user_role);
  const isAdmin = userRole === UserRole.MASTER_ROLE;
  const companies = useSelector((state: RootState) => state.layoutApp.layoutMasters.companies);

  /* 3. ログインユーザーの会社の色 */
  const { loginUserCompanyIconColor } = useUserCompanyColor();

  const getDefaultMachineIconColor = useCallback(
    (companyId: number, iconId?: number) => {
      const machineIconColor = machineIconSettings.find((v) => v.machine_icon_id === iconId)?.icon_color ?? "";
      const companyColor = companies.find((v) => v.company_id === companyId)?.icon_color ?? "";

      return normalizeHexColor(machineIconColor || (isAdmin ? companyColor : loginUserCompanyIconColor));
    },
    [machineIconSettings, companies, isAdmin, loginUserCompanyIconColor]
  );

  // 会社が変わったら会社の色、重機が変わったら重機の設定色
  return { getDefaultMachineIconColor };
};
